import { combineEpics } from 'redux-observable';

import {
    addMarketerProductEpic,
    changeMarketerProductEpic,
    fetchMarketerCardDataEpic,
    removeMarketerProductEpic
} from './marketerCard/marketerCard';
import {
    fetchMarketersDataEpic,
    resetUrlAfterFilterResetEpic
} from './marketersList';

const epics = [
    fetchMarketersDataEpic,
    fetchMarketerCardDataEpic,
    changeMarketerProductEpic,
    addMarketerProductEpic,
    removeMarketerProductEpic,
    resetUrlAfterFilterResetEpic
];

export const marketers = combineEpics(...epics);
